export const FETCH_PARKED_VISITS = "[GROUP_ADMIN] FETCH_PARKED_VISITS";
export const FETCH_PARKED_VISITS_START = "[GROUP_ADMIN] FETCH_PARKED_VISITS_START";
export const FETCH_PARKED_VISITS_SUCCESS = "[GROUP_ADMIN] FETCH_PARKED_VISITS_SUCCESS";
export const FETCH_PARKED_VISITS_ERROR = "[GROUP_ADMIN] FETCH_PARKED_VISITS_ERROR";
export const SET_PARKED_VISITS_PAGINATION = "[GROUP_ADMIN] SET_PARKED_VISITS_PAGINATION";

export const fetchParkedVisits = (data) => {
    return {
        type: FETCH_PARKED_VISITS,
        payload: data
    }
}